/* eslint no-undef: 0 */
/* eslint angular/document-service: 0 */
import find from 'lodash/find';
import forEach from 'lodash/forEach';

class AppCtrl {
    constructor(config, apiService, imagesService, dataService, $timeout, $scope, jsonBuilderService, $translate, callbacksService,
        windowDimensionsService, cartBarsService, handlesService, $anchorScroll, $rootScope, $window, $cookies) {
        this.config = config;
        this.apiService = apiService;
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.handlesService = handlesService;
        this.jsonBuilderService = jsonBuilderService;
        this.callbacksService = callbacksService;
        this.windowDimensionsService = windowDimensionsService;
        this.cartBarsService = cartBarsService;
        this.anchorScroll = $anchorScroll;
        this.$rootScope = $rootScope;
        this.$cookies = $cookies;

        this.stepsData = {};
        this.boxVisible = false;
        this.boxOptions = [];
        this.boxTitle = '';
        this.boxType = null;
        this.boxSelectedOptions = null;
        this.fieldName = null;
        this.$timeout = $timeout;
        this.$window = $window;
        this.selectedAccessories = [];
        this.multiSelect = false;
        this.selectedSerie = [];
        this.modalIsOpen = false;
        this.modalData = {};
        this.movableMullions = $scope.moveablemullions;
        this.visibleSide = 'inner';
        this.apiService.setProductId($scope.productid);
        this.apiService.setConfigurationId($scope.configurationid);
        this.apiService.setItemId($scope.editproduct);
        this.apiService.setEditSourceType($scope.editsource);
        this.isMobile = this.isMobile();
        this.editSource = $scope.editsource;
        this.editProduct = $scope.editproduct;
        this.isSalesman = $scope.issalesman;

        if ($scope.apiurl) {
            this.apiService.setApiUrl($scope.apiurl);
        }
        this.apiService.getData().then((data) => {
            this.productData = data.productInfo;
            this.dataService.validateData(data);
            data = this.setInitialDimensions(data);
            this.jsonBuilderService.setInitialData(data);
            this.dataService.setInitialData(data);
            this.dataLoaded = true;
        });
        this.getMullionSetupsFromCart();

        this.options = { dimensions: false, indexes: true, base: { side: this.visibleSide } };
        this.summaryOptions = {
            dimensions: {
                multiplier: 2,
                type: 'inner',
                indexes: true,
            },
            base: { side: this.visibleSide }
        };
        this.visibleOptions = {
            indexes: true
        };
        this.$rootScope.$on('updateDrawing', () => this.updateDrawing());
        this.$rootScope.$on('dimensionsChangeEvent', () => this.updateDrawing());
        this.$rootScope.$on('colorChangeEvent', () => this.updateDrawing());
        this.$rootScope.$on('savedToCartEvent', () => this.showAddToCartPopup());
        this.$rootScope.$on('changeConfiguratorBoxEvent', (event, type, defaultSelectedIdFieldName, modalTitle) => this.openBox(type, defaultSelectedIdFieldName, modalTitle));
        this.$rootScope.$on('resetStep', () => this.resetStep());

        $translate('MULLIONS_N_DIVIDERS').then((modalTitle) => {
            this.mullionsModalTitle = modalTitle;
        });
        $translate('NOT_CHANGED').then((modalTitle) => {
            this.mirrorIconTitle = modalTitle;
        });
        $translate('CART_URL').then((phrase) => {
            this.cartUrl = phrase;
        });
    }

    addToCart(withRedirect, showAddedToCartPopup = true) {
        this.apiService.addToCart(withRedirect, this.editProduct, showAddedToCartPopup);
    }

    setInitialDimensions(data) {
        const shape = JSON.parse(localStorage.getItem('shape'));
        if (shape) {
            data.data[0].attributes.height = Math.floor(shape.height);
            data.data[0].attributes.width = Math.floor(shape.width);
            data.data[0].attributes.bottomPanel = Math.floor(shape.bottom);
            data.data[0].relationships.unit.data.id = shape.unit;
            data.data[0].attributes.selectedHinge = shape.hingeSide;
            localStorage.removeItem('shape');
        }
        return data;
    }

    onInit() {
        this.productType = this.dataService.getProductType();
        if (this.dataService.data.data[0].type === 'window' || this.dataService.data.data[0].type === 'folding_door' || this.dataService.data.data[0].type === 'door') {
            if (!this.dataService.data.data[0].attributes.defaultInsideView) {
                this.visibleSide = 'outer';
                this.summaryOptions.base.side = 'outer';
                this.options.base.side = 'outer';
            } else {
                this.visibleSide = 'inner';
                this.summaryOptions.base.side = 'inner';
                this.options.base.side = 'inner';
            }
            this.visibleOptions = this.callbacksService.getButtonsOptions(Boolean(this.movableMullions), this.visibleSide);
        }
        if (this.dataService.getProductType() === 'door' && this.dataService.isProductWithGlass()) {
            this.config.boxes.forEach(box => {
                if (['GLAZING', 'GLASS'].indexOf(box.name) > -1) {
                    box.productTypes.push('door');
                }
            });
        }
        if (this.dataService.getProductType() === 'door' && this.dataService.isProductWithColor()) {
            this.config.boxes.forEach(box => {
                if (['COLOR'].indexOf(box.name) > -1) {
                    box.productTypes.push('door');
                }
            });
        }
        // Hide when no packages
        if (this.dataService.getAttributeOptions('packet').length === 0) {
            this.config.boxes[3].productTypes = [];
        }
        // Hide serie and glass step if we edit product to avoid redirection
        // @future-todo: make this better in future
        if (this.editSource) {
            this.config.boxes[0].productTypes = [];
            if (angular.isUndefined(this.dataService.data.included.glazingSpacers)) {
                this.config.boxes[1].productTypes = [];
            }
        }

        this.dataService.validateAccessories();
        this.selectedAccessories = this.dataService.getSelectedAccessories();
        this.selectedSerie = this.dataService.getSelectedOptionId('series');
        this.callbacksService.registerUpdateFunction(this.updateDrawing);
        this.getColorPalettes();
        const productType = this.dataService.getProductType();
        this.selectedBox = this.setInitialBox(productType);
        this.selectedBoxType = this.selectedBox.type;
        this.stepsData = this.getStepList();

        if (!this.isMobile) {
            this.openBox(this.selectedBox.type, this.selectedBox.defaultSelectedIdFieldName, this.selectedBox.subtitle);
        }
        // hide loader
        angular.element('.load').addClass('hidden');
        this.initSwiperGallery();
        this.dataService.populateAccessoriesModal();
    }

    resetStep() {
        const selectedBox = this.config.boxes[0];
        this.openBox(selectedBox.type, selectedBox.defaultSelectedIdFieldName, selectedBox.subtitle);
    }

    setInitialBox(productType) {
        let configId = this.dataService.apiService.configurationId;
        if (this.$cookies.get('default_config_color_' + configId)) {
            return this.config.boxes.find(box => box.type.indexOf('color') !== -1);
        } else {
            return this.config.boxes.find(box => box.productTypes.indexOf(productType) !== -1);
        }
    }

    getStepList() {
        const stepsData = { stepsList: [], stepsDetails: {} };
        let box = [];

        this.config.boxes.forEach((elem, key) => {
            if (this.isApiValue(elem.type) && elem.active) {
                if (elem.productTypes.indexOf(this.productType) === -1) {
                    return true;
                }
                stepsData.stepsList.push(elem.type);
                stepsData.stepsDetails[elem.type] = {
                    type: elem.type,
                    defaultSelectedIdFieldName: elem.defaultSelectedIdFieldName,
                    modalTitle: elem.modalTitle,
                };
            }
        });

        return stepsData;
    }

    changeStep(stepDirection) {
        let newStepIndex = 0;
        let newStepType = '';
        let newStepData = {};

        const boxType = this.boxType;
        const stepsCount = this.stepsData.stepsList.length;
        const currentStepIndex = this.stepsData.stepsList.indexOf(boxType);

        if ((currentStepIndex < (stepsCount - 1) && +stepDirection) === 1 || (currentStepIndex > 0 && +stepDirection === -1)) {
            newStepIndex = this.stepsData.stepsList.indexOf(boxType) + (+stepDirection);
            newStepType = this.stepsData.stepsList[newStepIndex];
            newStepData = this.stepsData.stepsDetails[newStepType];
            this.moreInfo = this.dataService.getMoreInfo(newStepData.defaultSelectedIdFieldName);
            this.selectedBoxCategory = newStepData.category;
            this.openBox(newStepData.type, newStepData.defaultSelectedIdFieldName, newStepData.modalTitle);
        }
    }

    openBox(type, fieldName, boxTitle) {
        if (this.boxVisible) {
            this.closeBox();
        }
        if (this.isMobile) {
            this.disableBodyScroll();
        }
        this.boxOptions = this.dataService.getAttributeOptions(type);
        this.boxSelectedOptions = this.dataService.getSelectedOptionId(fieldName);
        this.boxTitle = boxTitle;
        this.boxType = type;
        this.fieldName = fieldName;

        if (this.boxType === 'accessory') {
            this.multiSelect = true;
        }
        if (this.multiSelect) {
            const ids = [];

            forEach(this.boxSelectedOptions, (el) => {
                ids.push(el.id);
            });

            this.boxSelectedOptions = ids;
        }
        this.selectedBoxType = type;
        this.boxVisible = true;
        this.partDiscountImage = '';
        if (!angular.isUndefined(this.productData.partDiscountsImages)) {
            this.partDiscountImage = this.productData.partDiscountsImages[this.config.boxes.find(x => x.type == type).partType];
        }
    }

    closeBox(selectedOptions) {
        this.enableBodyScroll();
        const body = Array.from(document.getElementsByTagName('body'))[0];
        const html = Array.from(document.getElementsByTagName('html'))[0];
        html.classList.remove('fixed');
        body.classList.remove('fixed');

        if (angular.isDefined(selectedOptions)) {
            this.dataService.updateSelectedOptions(this.fieldName, selectedOptions, this.boxType);
            this.selectedAccessories = this.dataService.getSelectedAccessories();
        }
        this.boxOptions = [];
        this.boxSelectedOptions = null;
        this.boxTitle = '';
        this.boxType = null;
        this.fieldName = null;
        this.boxVisible = false;
        this.multiSelect = false;
    }

    updateDrawing(details) {
        const json = this.dataService.jsonService.getJson();
        if (angular.isDefined(details)) {
            json.sashes = details.sashes;
            json.dividers = details.dividers;
        }
        if (this.windowDimensionsService.noNewMullions &&
            this.callbacksService && this.callbacksService.lastCopy) {
            json.sashes = this.callbacksService.lastCopy.sashes;
            json.dividers = this.callbacksService.lastCopy.dividers;
        }
        if (this.callbacksService && (this.dataService.data.data[0].type === 'window' || this.dataService.data.data[0].type === 'folding_door')) {
            this.visibleOptions = this.callbacksService.getButtonsOptions(Boolean(this.movableMullions), this.visibleSide);
        }
        this.details = json;
        this.windowDimensionsService.noNewMullions = true;

        setTimeout(() => {
            this.dataService.setPrice();
        }, 100);
    }

    openModal(modalData) {
        this.modalIsOpen = true;
        this.modalData = modalData;
    }

    closeModal() {
        this.modalIsOpen = false;
    }

    getOrnamentName() {
        const glasses = this.dataService.getAttributeOptions('glass');
        const ornaments = this.dataService.getAttributeOptions('ornament');
        const currentFirstGlass = find(glasses,
            el => el.id === currentGlazing.attributes.insideGlass);
        const currentSecondGlass = find(glasses,
            el => el.id === currentGlazing.attributes.outsideGlass);
        const currentOrnament = find(ornaments,
            el => el.id === currentGlazing.attributes.ornament);

        let descriptionGlass;
        const descriptionOrnamnet = currentOrnament.id === '1' ? '' : currentOrnament.attributes.name;

        if (currentFirstGlass.id === '1' && currentFirstGlass.id === currentSecondGlass.id) {
            descriptionGlass = 'Normal';
        } else {
            descriptionGlass = 'Safety';
        }

        return `${descriptionGlass} ${descriptionOrnamnet}`;
    }

    getMullionSetupsFromCart() {
        this.apiService.getMullionSetupsFromCart().then((setups) => {
            this.cartBarsService.setMullionSetups(setups);
        });
    }

    getTitle(fieldName, type) {
        const selectedOption = this.dataService.getSelectedOption(fieldName, type);
        if (fieldName === 'sash') {
            return this.mullionsModalTitle;
        } else if ((angular.isUndefined(selectedOption) || selectedOption === null) && fieldName === 'mirrorReflection') {
            return this.mirrorIconTitle;
        } else if (angular.isUndefined(selectedOption) || selectedOption === null || fieldName === 'packet') {
            return '';
        } else if (fieldName === 'ornament') {
            return this.getOrnamentName();
        }

        return selectedOption.attributes.name;
    }

    getAccessoryImage(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    getImage(fieldName, type) {
        return this.imagesService.getImageUrl(fieldName, type);
    }

    getColorPalette(fieldName, type) {
        return this.dataService.getColorPalette(fieldName, type);
    }

    getBackgroundColor(fieldName, type) {
        return this.dataService.getBackgroundColorCode(fieldName, type);
    }

    getColorPalettes() {
        this.colorPalettes = this.dataService.getAttributeOptions('colorPalettes');
    }

    toggleDrawVisibleSide(side) {
        this.visibleSide = side;
        this.updateDrawing();
    }

    isMobile() {
        if (window.innerWidth <= 768) {
            return true;
        }
        return false;
    }

    isApiValue(type) {
        return this.dataService.getOptionAvailableStatus(type);
    }

    disableBodyScroll() {
        angular.element('body').addClass('no-scroll');
    }

    enableBodyScroll() {
        angular.element('body').removeClass('no-scroll');
        this.anchorScroll('configurator');
    }

    showAddToCartPopup() {
        angular.element('.addedToBasketConfiguratorPopup').addClass('--visible');
    }

    closeaddedToBasketPopup(goToCart) {
        if (goToCart) {
            this.$window.location.href = '/' + this.cartUrl;
            return false;
        }
        angular.element('.addedToBasketConfiguratorPopup').removeClass('--visible');
    }

    closeAccessoriesPopup() {
        angular.element('#modal-accessories-reminder').modal('hide');
    }

    initSwiperGallery() {
        angular.element('.configurator__image-gallery').removeClass('--hidden');

        angular.element(".configurator__image-gallery").lightGallery({
            download: false,
            autoplayFirstVideo: false,
            thumbnail: true,
            animateThumb: false,
            showThumbByDefault: true,
            currentPagerPosition: 'right',
            selector: '.configurator__gallery-image'
        });

        var swiper = new Swiper('.configurator__images-thumbnails', {
            slidesPerView: 8,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}

AppCtrl.$inject = ['config',
    'apiService',
    'imagesService',
    'dataService',
    '$timeout',
    '$scope',
    'jsonBuilderService',
    '$translate',
    'callbacksService',
    'windowDimensionsService',
    'cartBarsService',
    'handlesService',
    '$anchorScroll',
    '$rootScope',
    '$window',
    '$cookies'
];

export default AppCtrl;
